export const selectDropOffPointTitle = 'Seleccionar punto de recogida'

export const provinceField = 'province'

export const addressLineFields = [['line_1', 'house_number'], ['line_2'], ['postcode', 'locality'], [provinceField]]

export const comparedAddressFields = addressLineFields.flat()

export const loadingMessages = [
  'Enviando datos al servidor...',
  'Procesando información...',
  'Consultando opciones disponibles...',
  'Renderizando opciones...',
]
